import myWaitroseByCard from 'api/definitions/mywaitrosebycard';

import { PUT_MYWAITROSE_CARD } from 'redux/modules/mywaitrose/actions/types';
import { updateContactAddressAsync } from 'redux/modules/address/actions';
import { getContactAddressId, getAddressChosenFromModal } from 'redux/modules/address/selectors';

import historyUtils from 'utils/history';
import locator from 'utils/locator';
import urls from 'constants/urls';

type LinkMyWaitroseCardPayload = {
  myWaitroseCardNumber?: string;
  waitrose?: boolean | string;
  mywaitrose?: boolean | string;
  johnlewis?: boolean | string;
  johnlewisfinancialservices?: boolean | string;
};

export const linkMyWaitroseCard =
  ({ myWaitroseCardNumber }: LinkMyWaitroseCardPayload): WtrThunkAction<Promise<unknown>> =>
  async (dispatch, getState) => {
    const contactAddressId = getContactAddressId(getState());
    const addressChosenFromModal = getAddressChosenFromModal(getState());

    if (!myWaitroseCardNumber || !contactAddressId) {
      return Promise.resolve();
    }

    if (addressChosenFromModal) {
      await dispatch(updateContactAddressAsync({ contactAddressId }));
    }

    await dispatch({
      types: PUT_MYWAITROSE_CARD.triplet,
      apiCall: myWaitroseByCard.put({
        cardNumber: myWaitroseCardNumber,
        iHandleStatusCodes: [400, 409, 410],
      }),
    });

    historyUtils.replace(`${urls.linkMyWaitroseSuccess}${locator.search}`);

    return Promise.resolve();
  };
